import { createAction } from '@reduxjs/toolkit';

import {
  CONVERSION_TOOL_MAPPINGS_FETCH_REQUEST,
  CONVERSION_TOOL_MAPPINGS_FETCH_SUCCESS,
  CONVERSION_TOOL_MAPPINGS_FETCH_FAILURE,
  CONVERSION_TOOL_MAPPINGS_DELETE_REQUEST,
  CONVERSION_TOOL_MAPPINGS_DELETE_SUCCESS,
  CONVERSION_TOOL_MAPPINGS_DELETE_FAILURE,
} from './conversionToolMappings.const';

export const conversionToolMappingsFetchRequest = createAction(
  CONVERSION_TOOL_MAPPINGS_FETCH_REQUEST
);
export const conversionToolMappingsFetchSuccess = createAction(
  CONVERSION_TOOL_MAPPINGS_FETCH_SUCCESS
);
export const conversionToolMappingsFetchFailure = createAction(
  CONVERSION_TOOL_MAPPINGS_FETCH_FAILURE
);

export const conversionToolMappingsDeleteRequest = createAction(
  CONVERSION_TOOL_MAPPINGS_DELETE_REQUEST
);
export const conversionToolMappingsDeleteSuccess = createAction(
  CONVERSION_TOOL_MAPPINGS_DELETE_SUCCESS
);
export const conversionToolMappingsDeleteFailure = createAction(
  CONVERSION_TOOL_MAPPINGS_DELETE_FAILURE
);
